<template>
  <section class="case-study-section">
    <v-container id="case-study-container" class="py-sm-0 px-sm-3 animate-block">
      <v-row no-gutters class="case-row">
        <!-- Left Column - Years -->
        <v-col cols="5" md="5" class="years-col">
          <div class="years-wrapper">
            <div class="year-item year-2023">2023</div>
            <div class="year-item year-2024">2024</div>
            <div class="year-item year-2025">2025</div>
            <div class="year-item year-2026">2026</div>
            <div class="year-item year-2027">2027</div>
          </div>
        </v-col>

        <!-- Vertical Divider -->
        <div class="vertical-divider"></div>

        <!-- Right Column - Statistics Text -->
        <v-col cols="5" md class="stats-col">
          <div class="stats-content">
            <p class="stat-text">{{ $t('caseStudy.stat1') }}</p>
            <p class="stat-text">{{ $t('caseStudy.stat2') }}</p>
            <p class="stat-text">{{ $t('caseStudy.stat3') }}</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { animateOnScroll } from '@/mixins/animateOnScroll'

export default {
  name: 'CaseStudySection',
  mixins: [animateOnScroll]
}
</script>

<style scoped>
.case-study-section {
  padding: 0;
  background: rgb(28, 165, 190);
}

.case-row {
  min-height: 642px;
}

/* Left column - Years */
.years-col {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.years-wrapper {
  display: flex;
  flex-direction: column;
  margin-top: -60px;
  margin-bottom: -60px;
}

.year-item {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 200px;
  font-weight: 400;
  line-height: 0.82;
  letter-spacing: -0.07em;
  user-select: none;
}

/* Opacity per year */
.year-2023 {
  color: rgba(255, 255, 255, 0.2);
  animation: pulse-faded 5s ease-in-out infinite;
  animation-delay: 0s;
}

.year-2024 {
  color: rgba(255, 255, 255, 0.3);
  animation: pulse-faded 5s ease-in-out infinite;
  animation-delay: 1s;
}

.year-2025 {
  color: rgba(255, 255, 255, 0.55);
  animation: pulse-near 6s ease-in-out infinite;
}

.year-2026 {
  color: rgba(255, 255, 255, 1);
}

.year-2027 {
  color: rgba(255, 255, 255, 0.2);
  animation: pulse-faded 5s ease-in-out infinite;
  animation-delay: 2s;
}

/* Subtle breathing animations */
@keyframes pulse-faded {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }
}

@keyframes pulse-near {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.75;
  }
}

/* Vertical Divider */
.vertical-divider {
  width: 2px;
  align-self: stretch;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.6) 50%, rgba(255, 255, 255, 0) 100%);
  margin: 0 80px;
}

/* Right column - Stats */
.stats-col {
  display: flex;
  align-items: center;
}

.stats-content {
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 480px;
}

.stat-text {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 25px;
  letter-spacing: -0.01em;
  color: rgb(241, 241, 241);
  margin: 0;
}

/* Responsive */
@media (max-width: 1280px) {
  .year-item {
    font-size: 150px;
  }

  .stat-text {
    font-size: 20px;
    line-height: 23px;
  }

  .case-row {
    min-height: 520px;
  }
}

@media (max-width: 960px) {
  .case-row {
    min-height: 580px;
  }

  .years-wrapper {
    margin-top: -40px;
    margin-bottom: -40px;
  }

  .year-item {
    font-size: 110px;
  }

  .vertical-divider {
    margin: 0 24px;
  }

  .stats-content {
    gap: 28px;
  }

  .stat-text {
    font-size: 16px;
    line-height: 22px;
  }
}

@media (max-width: 600px) {
  #case-study-container {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .case-row {
    min-height: 500px;
  }

  .years-wrapper {
    margin-top: -30px;
    margin-bottom: -30px;
  }

  .year-item {
    font-size: 80px;
    margin-left: -20px;
    width: 100%;
  }

  .vertical-divider {
    margin: 0 16px;
  }

  .stats-content {
    gap: 20px;
  }

  .stat-text {
    font-size: 12px;
    line-height: 20px;
  }
}
</style>
